"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fakeLoginDRPicasoInitializer = exports.fakeLoginInitializer = void 0;
var features_1 = require("../../features");
Object.defineProperty(exports, "fakeLoginInitializer", { enumerable: true, get: function () { return features_1.fakeLoginInitializer; } });
Object.defineProperty(exports, "fakeLoginDRPicasoInitializer", { enumerable: true, get: function () { return features_1.fakeLoginDRPicasoInitializer; } });
//# sourceMappingURL=fakeLogin.initializers.js.map